import React, { useState } from "react";
import { Input, Checkbox, TimePicker, Space, Radio } from "antd";
import CustomInput from "../../CustomInput";
import UploadThumbnailComponent from "../../UploadThumbnailComponent";
import AddIcon from "../../images/Add";
import DeleteIcon from "../../images/DeleteClose";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import {
  getAddress,
  getBannerImages,
  getBranchFormDataPayload,
  getBranchName,
  getCloseTime,
  getDefaultInputData,
  getLatitude,
  getLongitude,
  getOpenTime,
  getSelectedOpenDays,
  getServiceCharge,
  getVat,
  validateBranchFormData,
} from "../../../services/restaurant-service";
import {CharLimit, openDays} from "../../../constant/constants";
import CustomLoader from "../../menu/CustomLoader";
import Helper from "../../../utils/Helper";
import CustomInputNumber from "../../CustomInputNumber";

export default function BranchCreateEditComponent({
  keyProp,
  records = {
    _data: {
      restaurantName: "",
      restaurantId: "",
      branchId: "",
      branchName: "",
      address: "",
      countryCode: "",
      phone: "",
      latitude: "",
      longitude: "",
      openTime: null,
      closeTime: null,
      status: "",
      openDays: [],
      vat: 0,
      serviceCharge: 0,
      customersPaymentOptions: [],
      adminsPaymentOptions: [],
      logo: "",
      offerImage: "",
      bannerImages: [],
      bin: "",
      vatRegNo: "",
      mushak: "",
      webAddress: "",
      socialLink: "",
      isVatIncluded: 'YES',
      isServiceChargeIncluded: 'YES',
      isSupplementaryDutyIncluded: 'YES'
    },
    setData: () => { },
    isAdmin: false,
  },
}) {
  const params = useParams();
  const navigate = useNavigate();
  const { TextArea } = Input;
  const { user, setNetworkCall, showNotification } = useUserStore();

  const [restaurantId, setRestaurantId] = useState(
    Boolean(records._data.restaurantId) ? records._data.restaurantId : ""
  );

  const [branchName, setBranchName] = useState(getBranchName(records._data));

  const [latitude, setLatitude] = useState(getLatitude(records._data));
  const [longitude, setLongitude] = useState(getLongitude(records._data));

  const [address, setAddress] = useState(getAddress(records._data));
  // not set to null
  const [openTime, setOpenTime] = useState(getOpenTime(records._data));

  // not set to null
  const [closeTime, setCloseTime] = useState(getCloseTime(records._data));
  const [status, setStatus] = useState(Boolean(records._data.status) ? records._data.status : "");
  const [logoImage, setLogoImage] = useState(Boolean(records._data.logo) ? records._data.logo : "");
  const [offerImage, setOfferImage] = useState(Boolean(records._data.offerImage) ? records._data.offerImage : "");
  const [bannerImages, setBannerImages] = useState(getBannerImages(records._data));

  const [selectedOpenDays, setSelectedOpenDays] = useState(getSelectedOpenDays(records._data));

  const [vat, setVat] = useState(getVat(records._data));

  const [serviceCharge, setServiceCharge] = useState(getServiceCharge(records._data));

  const [createLoading, setCreateLoading] = useState(false);

  const [inputData, setInputData] = useState(getDefaultInputData(records._data));

  const [webAddress, setWebAddress] = useState(records._data.webAddress || "");
  const [socialLink, setSocialLink] = useState(records._data.socialLink || "");

  const [branchIsVatIncluded, setBranchIsValIncluded] = useState(records._data.isVatIncluded || 'YES');
  const [branchIsServiceChargeIncluded, setBranchIsServiceChargeIncluded] = useState(records._data.isServiceChargeIncluded || 'YES');
  const [branchIsSupplementaryDutyIncluded, setBranchIsSupplementaryDutyIncluded] = useState(records._data.isSupplementaryDutyIncluded || 'YES');

  const handleTextFieldChange = (nameValueObj) => {
    const { name, value } = nameValueObj;

    if (name === "phone" && /[^\d]/.test(value)) {
      return;
    }

    setInputData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function onHandleAddBannerUpload() {
    const tempObj = {
      id: `${Date.now()}`,
      image: "",
    };

    setBannerImages((prevImages) => [...prevImages, tempObj]);
  }

  async function handleBannerDelete(bannerId, isLocalImage = false) {
    const deleteParams = {
      modelId: records._data.branchId,
      fieldName: "banner",
      fileId: bannerId,
      context: "RESTAURANT_EDIT",
    };

    if (deleteParams.modelId) {
      try {
        const response = await ApiService.ADMIN_FILE_DELETE(deleteParams, user.token.token);

        if (response.code !== 200) {
          showNotification(response.data.message || "Couldn't delete the file.");
          throw new Error("Couldn't delete the file.");
        }

        showNotification("Image deleted successfully.", false);
      } catch (error) {
        console.log(error);
      }
    }

    setBannerImages((prevImages) => prevImages.filter((item) => item.id !== bannerId));
  }

  function onHandleOpenDays(checkedValues) {
    setSelectedOpenDays([...checkedValues]);
  }

  const getFormatedData = (purpose = "create_validation") => {
    return getBranchFormDataPayload(
      purpose,
      records.isAdmin,
      restaurantId,
      branchName,
      address,
      latitude,
      longitude,
      openTime,
      closeTime,
      selectedOpenDays,
      vat,
      serviceCharge,
      records._data.customersPaymentOptions,
      records._data.adminsPaymentOptions,
      logoImage,
      offerImage,
      bannerImages,
      inputData.bin,
      inputData.vatRegNo,
      inputData.mushak,
      inputData.countryCode,
      inputData.phone,
      status,
      webAddress,
      socialLink,
      branchIsVatIncluded,
      branchIsSupplementaryDutyIncluded,
      branchIsServiceChargeIncluded
    );
  };

  const onHandleSaveBranch = async (e) => {
    e.preventDefault();

    let params = getFormatedData("create_validation");
    const errors = validateBranchFormData(params);

    if (errors.length > 0) {
      showNotification(errors[0]);
      return false;
    }

    try {
      setCreateLoading(false);
      params = getFormatedData("create_payload");

      setNetworkCall(true);
      const response = await ApiService.RESTAURANT_BRANCH_CREATE(params, user.token.token);

      if (!response || response.code !== 200) {
        showNotification(response.data.message);
        setNetworkCall(false);
        return;
      }
      setNetworkCall(false);
      setCreateLoading(false);
      showNotification(`Branch created successfully.`, false);
      navigate(`/restaurants/${records._data.restaurantId}/details`);
      return;
    } catch (err) {
      setCreateLoading(false);
      setNetworkCall(false);
      showNotification(err.response.data.message);
    }

    showNotification("Something went wrong. Please try again later.");
  };

  function onHandleCancelBranch() {
    if (records.isAdmin) {
      navigate(`/profile`);
    } else {
      navigate(`/restaurants/${params.restaurantId}/details`);
    }
  }

  async function onHandleUpdateBranch(e) {
    e.preventDefault();
    const rawParams = getFormatedData("edit_validation");
    const errors = validateBranchFormData(rawParams, "update_validation");

    if (errors.length > 0) {
      showNotification(errors[0]);
      return false;
    }

    let formData = getFormatedData("update_payload");

    const params = {
      branchId: records._data.branchId,
      data: formData,
    };
    try {
      setNetworkCall(true);
      const response = await ApiService.UPDATE_BRANCH(params, user.token.token);

      if (response.code !== 200) {
        setNetworkCall(false);
        showNotification(response.message);
        return;
      }
      setNetworkCall(false);
      showNotification(`Data updated successfully.`, false);
      if (records.isAdmin) {
        navigate(`/profile`);
        return;
      }
      navigate(`/restaurants/${records._data.restaurantId}/details`);
      return;
    } catch (err) {
      showNotification(err.response.message);
      setNetworkCall(false);
    }
  }

  function onHandleWebAddress(e) {
    setWebAddress(e.target.value);
  }

  function onHandleSocialLink(e) {
    setSocialLink(e.target.value);
  }

  function onHandleIsVatInclude(e) {
    const val = e.target.value;
    setBranchIsValIncluded(val);
  }


  return (
    <div className="font-uregular bg-[#FAFAFA] ">
      <CustomLoader />
      {createLoading && (
        <div className="branch-create-loading">
          <Spin fullscreen={true} size="large" />
        </div>
      )}
      <div className={`flex space-x-[50px] overflow-y-auto`}>
        {/* left side fields */}
        <div className="w-[50%] h-full px-[16px]">
          <div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">
                Restaurant Branch name
                <span className="text-red-500"> *</span>
              </div>
              <CustomInput
                value={branchName}
                setValue={setBranchName}
                showPadding={false}
                required={false}
                disabled={records.isAdmin ? true : false}
                onPressEnter={() => { }}
                placeholder="eg. Dhanmondi"
                maxLength={100}
                inputClasses="indent-1 outline-none h-[48px]"
              />
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">
                Location <span className="text-red-500"> *</span>
              </div>
              <div className="flex w-full gap-x-[20px]">
                <div className="w-[48%]">
                  <CustomInput
                    value={latitude}
                    setValue={setLatitude}
                    showPadding={false}
                    required={false}
                    onPressEnter={() => { }}
                    placeholder="Latitude"
                    inputClasses="indent-1 outline-none h-[48px]"
                  />
                </div>
                <div className="w-[48%]">
                  <CustomInput
                    value={longitude}
                    setValue={setLongitude}
                    showPadding={false}
                    required={false}
                    onPressEnter={() => { }}
                    placeholder="Longitude"
                    inputClasses="indent-1 outline-none h-[48px]"
                  />
                </div>
              </div>
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Branch Phone</div>

              <Space.Compact className="w-full h-[48px]">
                <Input style={{ width: "70px" }} value={`+${inputData.countryCode}`} />
                <Input
                  name="phone"
                  style={{ width: "100%" }}
                  value={inputData.phone}
                  placeholder="17XXXXXXXX"
                  onChange={(e) =>
                    handleTextFieldChange({
                      name: "phone",
                      value: e.target.value,
                    })
                  }
                  maxLength={11}
                />
              </Space.Compact>
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">
                Address <span className="text-red-500"> *</span>
              </div>
              <TextArea
                value={address}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length > CharLimit.Address) return;
                  setAddress(value);
                }}
                placeholder="Address"
                autoSize={{ minRows: 4, maxRows: 10 }}
              />
              <div className="mt-1 text-[12px] text-gray-600 italic">Char limit {CharLimit.Address} ({address.length})</div>
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Website url</div>
              <Input
                value={webAddress}
                onChange={onHandleWebAddress}
                placeholder="https://www.yourrestaurantsite.com"
                className="indent-1 outline-none h-[48px]"
              />
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Social link</div>
              <Input
                value={socialLink}
                onChange={onHandleSocialLink}
                placeholder="https://www.yourrestaurantsite.com"
                className="indent-1 outline-none h-[48px]"
              />
            </div>

            {/* open and close time */}
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Open time and Close time</div>
              <div className="flex space-x-[20px]">
                <TimePicker
                  format="hh:mm A"
                  value={openTime}
                  // defaultOpenValue={dayjs("00:00 AM", "hh:mm A")}
                  defautValue={openTime}
                  placeholder="Open Time"
                  use12Hours={true}
                  onChange={(value) => setOpenTime(value)}
                  className="indent-1 h-[48px]"
                  allowClear
                />
                <TimePicker
                  format="hh:mm A"
                  value={closeTime}
                  // defaultOpenValue={dayjs("00:00 AM", "hh:mm A")}
                  defautValue={closeTime}
                  placeholder="Close Time"
                  use12Hours={true}
                  onChange={(value) => setCloseTime(value)}
                  className="indent-1 h-[48px]"
                  allowClear
                />
              </div>
            </div>

            {/* open days */}
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Open days</div>
              <div className="opendays-checkbox-group ">
                <Checkbox.Group
                  // autoFocus=false,
                  options={openDays}
                  defaultValue={selectedOpenDays}
                  onChange={onHandleOpenDays}
                  className="border-none"
                />
              </div>
            </div>

            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">VAT Included ?</div>
              <div>
                <Radio.Group
                  onChange={onHandleIsVatInclude}
                  name="radiogroup"
                  value={branchIsVatIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>

            <div className="flex gap-4 pb-[20px]">
              <div>
                <div className="font-bold mb-1 text-sm flex flex-row">VAT (%) 
                  {/* {branchIsVatIncluded && <span className="text-red-500 pl-2">*</span>} */}
                  </div>
                <CustomInputNumber
                  name="vat"
                  value={vat}
                  setValue={setVat}
                  placeholder={'Vat in percent, i.e., 9.5'}
                  isDecimalAllowed={true}
                  min={0}
                  max={100}
                  inputClasses="indent-1 outline-none h-[48px]"
                />
              </div>
             
            </div>

            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Supplementary Duty Included ?</div>
              <div>
                <Radio.Group
                  onChange={(e) => setBranchIsSupplementaryDutyIncluded(e.target.value)}
                  name="radiogroup"
                  value={branchIsSupplementaryDutyIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>
            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Service Charge Included ?</div>
              <div>
                <Radio.Group
                  onChange={(e) => setBranchIsServiceChargeIncluded(e.target.value)}
                  name="radiogroup"
                  value={branchIsServiceChargeIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>

            <div className="flex gap-4 pb-[20px]">
              <div>
                <div className="font-bold mb-1 text-sm flex flex-row">Service Charge (%)</div>
                <CustomInputNumber
                  name="serviceCharge"
                  value={serviceCharge}
                  setValue={setServiceCharge}
                  placeholder={'Service Charge (%) like 3.5'}
                  isDecimalAllowed={true}
                  min={0}
                  max={100}
                  inputClasses="indent-1 outline-none h-[48px]"
                />
              </div>
            </div>

            <div className="flex gap-4">
              <div>
                <CustomInput
                  name="bin"
                  value={inputData.bin}
                  defaultValue={undefined}
                  setValue={handleTextFieldChange}
                  shouldSetValueSetObj={true}
                  showPadding={false}
                  required={false}
                  onPressEnter={() => { }}
                  placeholder="BIN"
                  inputClasses="indent-1 outline-none h-[48px]"
                  label={"BIN"}
                  labelClass="font-bold mb-1"
                  allowNumberAndHyphen={true}
                  maxLength={16}
                />
              </div>
              <div>
                <CustomInput
                  name="vatRegNo"
                  value={inputData.vatRegNo}
                  defaultValue={undefined}
                  setValue={handleTextFieldChange}
                  shouldSetValueSetObj={true}
                  showPadding={false}
                  required={false}
                  onPressEnter={() => { }}
                  placeholder="Service Charge"
                  inputClasses="indent-1 outline-none h-[48px]"
                  label={"Vat Reg. No."}
                  labelClass="font-bold mb-1"
                  allowNumberAndHyphen={true}
                  maxLength={12}
                />
              </div>
              <div>
                <CustomInput
                  name="mushak"
                  value={inputData.mushak}
                  defaultValue={undefined}
                  setValue={handleTextFieldChange}
                  shouldSetValueSetObj={true}
                  showPadding={false}
                  required={false}
                  onPressEnter={() => { }}
                  maxLength={6}
                  alphaNumericWithDot={true}
                  placeholder="Mushak"
                  inputClasses="indent-1 outline-none h-[48px]"
                  label={"Mushak"}
                  labelClass="font-bold mb-1"
                />
              </div>
            </div>

            {records.isAdmin === false && (
              <div className="pb-[20px]">
                <div className="pb-2 font-p_medium font-[12px]">Select status</div>
                <div className="res-status-select">
                  <select value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Published">Published</option>
                    <option value="Pending">Pending</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* right side fields */}
        <div className="w-[50%] h-full px-[70px]">
          <div className="mb-[20px]">
            <UploadThumbnailComponent
              key_id="upload-logo"
              placeholderText={"Upload Logo"}
              setImage={setLogoImage}
              prevImage={logoImage}
              deleteParams={{
                modelId: records._data.branchId,
                fieldName: "logo",
                context: "RESTAURANT_EDIT",
              }}
            />
          </div>

          {records.title !== "Edit" && (
            <div>
              <div className="mb-[20px]">
                <UploadThumbnailComponent
                  key_id="upload-offer-image"
                  placeholderText={"Upload Offer Image"}
                  setImage={setOfferImage}
                  prevImage={offerImage}
                  aspect={16 / 9}
                  context="OFFER_IMAGE"
                  deleteParams={{
                    modelId: records._data.branchId,
                    fieldName: "offerImage",
                    context: "RESTAURANT_EDIT",
                  }}
                />
              </div>
              <div className="">
                {/* header with button */}
                <div className="my-[20px] flex items-center justify-between">
                  <h1 className="font-p_medium">Upload Banners</h1>
                  <AddIcon
                    attributes={{
                      color: "#000000",
                      size: "30.75",
                      classes: "cursor-pointer",
                    }}
                    clickHandler={onHandleAddBannerUpload}
                  />
                </div>

                <div>
                  {bannerImages.map((banner, idx) => {
                    if (Boolean(banner.id)) {
                      return (
                        <div id={banner.id} key={banner.id} className="relative mb-[20px] flex items-start">
                          <div className="flex-grow">
                            <UploadThumbnailComponent
                              key_id={`banner-upload-${idx}`}
                              placeholderText={`Banner Upload`}
                              setImage={setBannerImages}
                              bannerId={banner.id}
                              banners={bannerImages}
                              prevImage={banner.image || banner.path}
                              context="BANNER_IMAGE"
                              deleteParams={{
                                modelId: records._data.branchId,
                                fieldName: "banner",
                                fileId: banner.id,
                                context: "RESTAURANT_EDIT",
                              }}
                            />
                          </div>
                          <div className="absolute right-[-30px] w-[30px] py-3">
                            <DeleteIcon
                              attributes={{
                                color: "#EE3169",
                                size: "24",
                                classes: "cursor-pointer ml-[7px]",
                              }}
                              clickHandler={() => handleBannerDelete(banner.id, banner.isLocalImage)}
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="w-full mt-[30px] flex items-center justify-center gap-x-[20px]">
        <button
          className="h-[42px] w-[100px] bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] rounded-lg"
          onClick={onHandleCancelBranch}
        >
          Cancel
        </button>
        {keyProp === "create" && (
          <button
            className="h-[42px] w-[100px] bg-[#000000] text-white text-[14px] 
          font-bold leading-[16px] rounded-lg"
            onClick={onHandleSaveBranch}
          >
            Save
          </button>
        )}
        {keyProp === "edit" && (
          <button
            className="h-[42px] w-[100px] bg-[#000000] text-white text-[14px] 
          font-bold leading-[16px] rounded-lg"
            onClick={onHandleUpdateBranch}
          >
            Update
          </button>
        )}
      </div>
    </div>
  );
}
